import { create } from 'zustand'

const useDataStatusStore = create((set) => ({
  status: 'ready', // 'loading', 'fetching_enquiries', 'ready'
  message: 'Data ready',

  setStatus: (status, message) => set({ status, message }),

  reset: () => set({ status: 'ready', message: 'Data ready' })
}))

export default useDataStatusStore
